import { render, staticRenderFns } from "./newStore.vue?vue&type=template&id=5918a308"
import script from "./newStore.vue?vue&type=script&lang=js"
export * from "./newStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports